import { render, staticRenderFns } from "./ZTableHeadSort.vue?vue&type=template&id=6c70fa57&scoped=true&"
import script from "./ZTableHeadSort.vue?vue&type=script&lang=js&"
export * from "./ZTableHeadSort.vue?vue&type=script&lang=js&"
import style0 from "./ZTableHeadSort.vue?vue&type=style&index=0&id=6c70fa57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c70fa57",
  null
  
)

export default component.exports